const en = {
  menus: {
    overview: 'Overview',
    diagnostics: 'Diagnostics',
    dataExplorer: 'Data Explorer',
    events: 'Events',
    logs: 'Logs',
    settings: 'Settings',
    updates: 'Updates',
    performanceIndicators: 'Performance indicators',
    help: 'Help',
    feedback: 'Feedback',
  },
};

const nl = {
  menus: {
    overview: 'Overzicht',
    diagnostics: 'Diagnostiek',
    dataExplorer: 'Data Verkenner',
    events: 'Evenementen',
    logs: 'Logs',
    settings: 'Instellingen',
    updates: 'Updates',
    performanceIndicators: 'Performance indicators',
    help: 'Hulp',
    feedback: 'Feedback',
  },
};

const getClientSideTranslations = (language: string) => {
  return language === 'nl' ? nl : en;
};

export default getClientSideTranslations;
